import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
type ComingSoonProps = {
  title: string;
  description: string;
};
export function ComingSoon({
  title,
  description
}: ComingSoonProps) {
  return <main className="mx-auto flex min-h-[80vh] max-w-shell flex-col justify-center px-6 py-32 lg:px-10" data-id="element-193" data-mp="4c55tzx84qi2">
      <p className="text-[11px] uppercase tracking-label text-graphite" data-id="element-194" data-mp="3vfk1jmo240ax">Page en préparation</p>
      <h1 className="mt-5 max-w-3xl font-display text-[clamp(2.5rem,6vw,5rem)] leading-[0.98] tracking-tight" data-id="element-195" data-mp="d9p91eencwvb">
        {title}
      </h1>
      <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-graphite" data-id="element-196" data-mp="n11yjzcz3ay6">{description}</p>
      <Link to="/" className="group mt-10 inline-flex w-fit items-center gap-3 border-b border-ink pb-1 text-[11px] uppercase tracking-label" data-id="element-197" data-mp="i1ytwg0wn6qq">
        <ArrowLeftIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:-translate-x-1" data-id="element-198" data-mp="wzrazcm3o371" />
        Retour à l’accueil
      </Link>
    </main>;
}